import { put, takeLatest, call } from 'redux-saga/effects'
import { SubmissionError } from 'redux-form'

import * as postLiveReason from '../modules/postLiveReason'
import { submitPostLiveReason } from '../api'

function* submitPostLiveReasonSaga(action) {
  const { data, id, resolve, reject } = action.payload

  try {
    const response = yield submitPostLiveReason(data, id)
    yield put(postLiveReason.submitReasonSuccess(response))
    yield call(resolve)
  } catch (error) {
    yield call(
      reject,
      new SubmissionError({
        _error: 'Something went wrong. Please try again.',
      }),
    )
  }
}

export default function* watchPostLiveReasonSaga() {
  yield takeLatest(postLiveReason.SUBMIT_REASON, submitPostLiveReasonSaga)
}
